import { closest, Component, element as $, KEY_ENTER } from '@contorion/core';
import { ResultListComponent } from './result-list.component';
import { SearchInputComponent } from './search-input.component';
import { SearchService } from '../services/search.service';

const SELECTOR_INPUT: string = '.js-searchbar-input';
const SELECTOR_HEADER: string = '.js-search-bar-header';
const SELECTOR_CLOSE: string = '.js-close-button';
const SELECTOR_RESULT_LIST: string = '.js-search-result-list';
const SELECTOR_RESULT_LIST_V2: string = '.js-search-result-list-v2';
const SELECTOR_TOOLTIP_ERROR: string = '.js-tooltip-error';
const SELECTOR_OVERLAY: string = '.js-search-bar-overlay';
const CLASS_HIDDEN: string = 'hidden';
const CLASS_ACTIVE: string = 'active';
const CLASS_FIXED: string = 'fixed';

export class SearchComponent extends Component {
    protected service: SearchService;
    protected input: SearchInputComponent;
    protected resultList: ResultListComponent;

    protected get isFlyout(): boolean {
        return this.element.dataset.flyout !== '';
    }


    protected get resultListElement(): HTMLElement {
        return <HTMLElement> $(SELECTOR_RESULT_LIST);
    }

    protected get resultListElementV2(): HTMLElement {
        return <HTMLElement> $(SELECTOR_RESULT_LIST_V2);
    }

    protected get overlay(): HTMLElement {
        return <HTMLElement> $(SELECTOR_OVERLAY);
    }

    protected get searchInput(): HTMLInputElement {
        return <HTMLInputElement> $(SELECTOR_INPUT);
    }

    protected get header(): HTMLElement {
        return <HTMLElement> $(SELECTOR_HEADER);
    }

    protected get closeButton(): HTMLElement {
        return <HTMLElement> $(SELECTOR_CLOSE);
    }

    protected get inputMaxLength(): number {
        return parseInt(this.searchInput.getAttribute('maxlength'));
    }

    protected get tooltipError(): HTMLElement {
        return <HTMLElement> $(SELECTOR_TOOLTIP_ERROR);
    }

    constructor(protected element: HTMLFormElement) {
        super(element);

        this.service = new SearchService();
        this.input = new SearchInputComponent(
            this.searchInput,
            this,
            this.service,
            this.isFlyout,
        );
        this.resultList = new ResultListComponent(
            this.resultListElement,
            this.service,
        );

        this.initEvents();
    }

    public submit(): void {
        this.element.submit();
    }

    public search(): void {
        this.service.search();
    }

    protected initEvents(): void {
        this.service.keyboardEvent.subscribe(this.onKeyboardEvent.bind(this));
        document.body.addEventListener('click', this.onBodyClick.bind(this));
    }

    protected onKeyboardEvent(e: KeyboardEvent): void {
        if (e === null) {
            return;
        }

        this.checkInputValue();

        switch (e.keyCode) {
            case KEY_ENTER:
                e.preventDefault();

                if (this.resultList.row === -1) {
                    this.submit();
                }

                break;
            default:

                break;
        }
    }

    protected onBodyClick(e: MouseEvent): void {
        if (closest(<Element> e.target, SELECTOR_RESULT_LIST)
            || closest(<Element> e.target, SELECTOR_RESULT_LIST_V2)
            || closest(<Element> e.target, SELECTOR_INPUT)) {
            return;
        }

        this.resultListElement?.classList.add(CLASS_HIDDEN);
        this.resultListElementV2?.classList.add(CLASS_HIDDEN);
        this.overlay?.classList.add(CLASS_HIDDEN);
        this.closeButton?.classList.add(CLASS_HIDDEN);
        this.header.classList.remove(CLASS_ACTIVE);
        document.body.classList.remove(CLASS_FIXED);
    }

    protected reset(): void {
        this.input.value = '';
        this.resultList.reset();
        this.closeButton?.classList.add(CLASS_HIDDEN);
    }

    protected checkInputValue(): void {
        if (this.input.value.length === 0) {
            this.tooltipError.classList.add(CLASS_HIDDEN);
            this.reset();

            return;
        }

        if (this.input.value.length === this.inputMaxLength) {
            this.tooltipError.classList.remove(CLASS_HIDDEN);

            return;
        }

        if (!this.tooltipError.classList.contains(CLASS_HIDDEN)) {
            this.tooltipError.classList.add(CLASS_HIDDEN);
        }
    }
}
